<div class="main-contents">
    <div class="webslider">    
        <owl-carousel-o [options]="customOptions">
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/websites/web-slider-01.jpg">
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/websites/web-slider-02.jpg">
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/websites/web-slider-03.jpg">
                </div>
            </ng-template>   
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/websites/web-slider-04.jpg">
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/websites/web-slider-05.jpg">
                </div>
            </ng-template>   
        </owl-carousel-o>
    </div>
    <div class="register-form padding-top-30">
        <div class="container">
                <h2 class="text-center">Login</h2>
            <div class="row">
                <div class="col-md-6 padding-bottom-30">
                    <div class="alert alert-success" *ngIf="isUserLogin">                        
                        You are already logged in.
                    </div>
                    <div class="" *ngIf="!isUserLogin">
                        <form [formGroup]="loginForm" (ngSubmit)="postdata(loginForm)" autocomplete="off" >
                            <div class="form-group">
                                <label for="email">Email</label>
                                <input type="email" name="email" formControlName="email" autocomplete="off" class="form-control input-sm" placeholder="Email">
                            </div>
                            <div class="alert alert-danger" *ngIf="loginForm.get('email').hasError('required') && loginForm.get('email').touched">
                                Please enter email.
                            </div>
                            <div class="alert alert-danger" *ngIf="loginForm.get('email').hasError('maxlength') && loginForm.get('email').touched">
                                Maximum 30 characters are allowed.
                            </div>
                            <div class="alert alert-danger" *ngIf="loginForm.get('email').hasError('email') && loginForm.get('email').touched">
                              Please enter the correct email format.
                            </div>
                            <div class="form-group">
                            <label for="Password">Password</label>
                            <input type="password" name="Password" formControlName="password" autocomplete="off" class="form-control input-sm" placeholder="Password">
                            </div>
                            <div class="alert alert-danger" *ngIf="errorMsg">                                
                                The username or password you entered is incorrect or has not been activated.
                            </div>
                            <button type="submit" class="btn btn-success" >Login</button>
                        </form>
                    </div>
                </div>
                <div class="col-md-6 social-media padding-bottom-30">
                    <instagram-post></instagram-post>
                    <tumblr-posts></tumblr-posts>
                </div>
            </div>
        </div>
        </div>
</div>
